import { expose } from '@gower/react-ui/store';
import { QuickResponseFormStore } from 'lib/components/quick-response/store';

class QuickResponseStore extends QuickResponseFormStore {

}

export const { provider, useStore } = expose( QuickResponseStore );